import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { CircleButton, HelpTooltip } from "./DisabledBookieCircle.styled";

export const DisabledBookieCircle = ({ children, id, placement = "right", width = undefined, color = 'red' }) => {
  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <HelpTooltip id={id} width={width}>
          {children}
        </HelpTooltip>
      }
    >
      {(props) => (
        <CircleButton {...props} color={color} size="sm" variant="secondary">
        </CircleButton>
      )}
    </OverlayTrigger>
  );
};
